import React, { Component } from 'react';
import axios from 'axios';
import '../../Asset/Css/Site.css';
import Select from 'react-select';
import global from '../global';
import ReCAPTCHA from 'react-google-recaptcha';
import 'react-notifications-component/dist/theme.css'
import { Card, Row, Col, InputGroup, FormControl, Modal, Button } from 'react-bootstrap';
import '../../Asset/Css/util.css';
import '../../Asset/Css/main.css';
import { config } from '../../Constants';
import { store } from 'react-notifications-component';
import ReactNotification from 'react-notifications-component';
import mainBG from '../../Asset/Images/easy-dividend-bg.png';
import goBack from '../../Asset/Images/previous-icon.png';
import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import EasyDividendLogo from '../../Asset/Images/easy-dividend-logo.png';


export class NonResident extends Component {
    static displayName = NonResident.name;

    constructor(props) {
        super(props);
        this.state = {
            isVerified: false,
            DPID: '',
            Captcha: '',
            residentDetails: [],
            companyList: [],
            BeneficiaryName: '',
            PAN: '',
            showDP: 'N',
            companyID: -1,
            isSearchable: true,
            isNRDetailsAvailable: false,
            showValidateItem: 'none',
            AssignmentName: '',
            AssignmentCode: -1,
            Email: '',
            url: '',  
            flag: 'NR',
            isCaptchaVisible: 'block',

        };

        //this.CheckValidate();

        this.initialState = this.state;

        this.handleChange = this.handleChange.bind(this);
        this.handleVerify = this.handleVerify.bind(this);
        this.handleCompany = this.handleCompany.bind(this);

    }

    componentDidMount() {
        loadCaptchaEnginge(6);
    };

    checkCaptcha = () => {
        let user_captcha_value = this.state.Captcha;

        if (validateCaptcha(user_captcha_value) == true) {
            return true;
        }
        else {
            return false;
        }

    };

    closeYesModal = () => this.setState({ isNRDetailsAvailable: false });

    handleChange(e) {

        const { name, value } = e.target;

        if (name == "BeneficiaryName") {
            this.setState({ [name]: value.replace(/[^a-zA-Z0-9&' ]/g, "") });
        }
        else {
            this.setState({ [name]: value });
        }

    }

    handleYes = (e) => {
        window.location.href = config.url.Web_URL + `/NonResident/FileUpload?AN=` + window.btoa(this.state.AssignmentCode) + '&EM=' + window.btoa(this.state.Email) + '&DP=' + window.btoa(this.state.showDP);
    }

    handleVerify = (e) => {
        debugger

        if (this.state.DPID == "" || this.state.DPID == null) {
            this.showNoti("Notification", "DP ID/Folio ID is required.", "danger");
            return;
        }

        if (this.checkCaptcha()) {
            this.setState({
                flag: 'NR'
            });

            const objLogin = this.state;

            axios.post(global.UserManagement.VerifyDPIDAPI, objLogin,
                { responseType: 'json' })
                .then(response => {
                    debugger
                    if (response.status) {

                        this.setState({
                            residentDetails: response.data.data,
                        });

                        const optionsCompany = response.data.AssignmentList.map(d => ({
                            "value": d.ID,
                            "label": d.Label
                        }))

                        if (response.data.status) {

                            this.setState({
                                BeneficiaryName: this.state.residentDetails[0].BeneficiaryName,
                                PAN: this.state.residentDetails[0].PAN,
                                Email: this.state.residentDetails[0].EmailID,
                                companyList: optionsCompany,
                                showValidateItem: 'block',
                                isCaptchaVisible: "none",

                            });
                        }
                        else {
                            this.setState({
                                BeneficiaryName: '',
                                PAN: '',
                                Email: '',
                                companyList: optionsCompany,
                                showValidateItem: 'block',
                                isCaptchaVisible: "none",
                            });
                        }
                    }
                    else {
                        this.setState({
                            residentDetails: []
                        });
                    }
                })
                .catch(error => {
                    console.log(error);
                })

            //axios.post(global.UserManagement.GetCompanyDetailsDDLAPI, objLogin,
            //    { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } })
            //    .then(response => {
            //        debugger
            //        if (response.data.status) {
            //            const optionsCompany = response.data.data.map(d => ({
            //                "value": d.ID,
            //                "label": d.Label
            //            }))
            //            this.setState({
            //                companyList: optionsCompany
            //            })
            //        }
            //        else {
            //            this.setState({
            //                companyList: []
            //            })
            //            console.log(this.state.companyList);
            //        }
            //    })
            //    .catch(error => {
            //        console.log(error);
            //    });
        }
        else {
            this.showNoti("Notification", "Captcha Does Not Match", "danger");
            return;
        }
    }


    onCAPTCHAChange = (e) => {
        this.setState({ isVerified: true });
    }

    handleCompany = (e) => {

        if (e.value != '') {
            this.setState({
                AssignmentCode: e.value,
                AssignmentName: e.label

            });
        }
    }

    handleProceed = (e) => {

        debugger
        e.preventDefault();

        if (this.state.DPID == "" || this.state.DPID == null) {
            this.showNoti("Notification", "DP ID/Folio ID is required.", "danger");
            return;
        }

        if (this.state.Email == "" || this.state.Email == null) {
            this.showNoti("Notification", "Email is required.", "danger");
            return;
        }

        if (this.state.AssignmentCode == -1 || this.state.AssignmentCode == "" || this.state.AssignmentCode == null) {
            this.showNoti("Notification", "Listed Company Name is required.", "danger");
            return;
        }

        if (this.state.Email !== "") {
            var regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

            if (!regex.test(this.state.Email)) {
                this.showNoti("Notification", "Invalid Email Address.", "danger");
                return;
            }
        }

        if (this.checkCaptcha()) {

            axios.get(global.UserManagement.GetNRSubmittedDetailsAPI + '?AssignmentCode=' + this.state.AssignmentCode + '&DPID=' + this.state.DPID + '&BeneficiaryName=' + this.state.BeneficiaryName,
                { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } })
                .then(response => {
                    debugger
                    if (response.data.Status) {
                        if (response.data.FormExists == "N") {
                            this.setState({
                                showDP: response.data.ShowDataPrivacy
                            })

                            window.location.href = config.url.Web_URL + `/NonResident/FileUpload?AN=` + window.btoa(this.state.AssignmentCode) + '&EM=' + window.btoa(this.state.Email) + '&DP=' + window.btoa(response.data.ShowDataPrivacy);
                        }
                        else {
                            this.setState({
                                isNRDetailsAvailable: true,
                                showDP: response.data.ShowDataPrivacy
                            })
                        }
                    }
                    else {
                        this.showNoti("Notification", "Unable to Verify DPID Details", "danger");
                        return;
                    }
                })
                .catch(error => {
                    this.showNoti("Notification", "Unable to Verify DPID Details", "danger");
                    return;
                });



        }
        else {
            this.showNoti("Notification", "Captcha Does Not Match", "danger");
            return;
        }

    }

    handleCancel = (e) => {
        e.preventDefault();
        window.location.href = config.url.Web_URL;
    }
  
    showNoti(title, message, type) {
        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });
    };

    render() {
        const {
            isSearchable
        } = this.state;

    
        return (
            <div>
                <ReactNotification />

                <div className="limiter">
                    <div className="container-login100" style={{ backgroundImage: 'url("' + mainBG + '")' }}>
                        <div className="content-page">
                            <img src={EasyDividendLogo} alt="Logo" className="logo-img" />
                            <Row className="">
                                <Col md={1}>
                                </Col>
                                <Col md={5} className="login-form-1">
                                    <h3>Note</h3>

                                    <div className="form-group">
                                        Members with NSDL account: 8-character DP ID followed by 8-digit client ID. (For example, if your DP ID is IN300*** and Client ID is 12******, then IN300***12******)
                                    </div>
                                    <div className="form-group">
                                        Members with CSDL account: 16-digit Beneficiary ID. (For example, if your Beneficiary ID is 12**************, then 12**************)
                                    </div>
                                    <div className="form-group">
                                        Dear Shareholder, In case of shareholder having multiple Folio No/DPID & Client, then any Folio No/DPID & Client can be used to create the login credentials. Any Folio No/DPID & Client and Permanent Account Number (PAN) can be used for registration at this portal. The Tax forms or various documents submitted at the portal would be considered for all other Folio No/DPID & Client which has same Permanent Account Number (PAN) registered as per the information available with the depositories (NSDL/CDSL) or by the Registrar.
                                    </div>
                                </Col>
                                <Col md={5} className="login-form-2">
                                    <h3 className="xlogin-form-header legend lastdocTitle">Non-Resident Shareholder</h3>

                                    <label className="required-field">DP ID/Folio ID</label>
                                    <FormControl type="text" name="DPID" key="txtDPID" className="m-t-10"
                                        value={this.state.DPID}
                                        placeholder="Max 16 Characters"
                                        maxLength="16"
                                        onChange={this.handleChange}
                                    />

                                    <div style={{ display: `${this.state.isCaptchaVisible}` }}>
                                        <label className="required-field m-b-20 m-t-20">Enter Captcha:</label>
                                        <LoadCanvasTemplate className="w-100" />
                                        <FormControl type="text" name="Captcha" key="txtCaptcha" className="m-t-10" maxLength="6"
                                            value={this.state.Captcha}
                                            onChange={this.handleChange}
                                            placeholder="Max 6 Characters"
                                            autoComplete="off"
                                        />
                                        <button className="btn btn-primary float-left w-100 m-r-10 m-b-10 m-t-10" onClick={this.handleVerify} >
                                            Verify
                                        </button>
                                    </div>

                                    <div className="m-t-20" style={{ display: `${this.state.showValidateItem}` }}>
                                        <label className="required-field">Shareholder</label>
                                        <FormControl type="text" name="BeneficiaryName" key="txtBeneficiaryName" className="m-t-10" maxLength="100"
                                            value={this.state.BeneficiaryName}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="m-t-20" style={{ display: `${this.state.showValidateItem}` }}>
                                        <label className="required-field">Email</label>
                                        <FormControl type="text" name="Email" key="txtEmail" className="m-t-10" maxLength="100"
                                            value={this.state.Email}
                                            onChange={this.handleChange}
                                            placeholder="Max 100 Characters"
                                            maxLength="100"
                                        />
                                    </div>

                                    <div className="m-t-20" style={{ display: `${this.state.showValidateItem}` }}>
                                        <label className="required-field">Listed Company Name</label>
                                        <Select
                                            className="basic-single"
                                            classNamePrefix="select Company"
                                            placeholder="Select Company"
                                            value={this.state.companyList.find(obj => obj.value === this.state.AssignmentCode)}
                                            isSearchable={isSearchable}
                                            options={this.state.companyList}
                                            onChange={this.handleCompany}
                                        />
                                    </div>

                                    

                                    <div className="m-t-20" style={{ display: `${this.state.showValidateItem}` }}>
                                        <button className="btn btn-primary float-right w-100 m-b-10 m-t-10" onClick={this.handleProceed}>
                                            Proceed
                                    </button>
                                    </div>

                                    <img src={goBack} className="go_back" onClick={this.handleCancel} alt="Go to previous page" title="Go to previous page" />


                                </Col>
                                <Col md={1}>
                                </Col>
                            </Row>
                            <Row>
                                <Modal show={this.state.isNRDetailsAvailable} onHide={this.closeYesModal}>
                                    <Modal.Header closeButton>
                                        <Modal.Title className="modal_title">Notification</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body className="modal_body">
                                       It seems that you have already uploaded the declaration. Do you still wish to overwrite?
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button className="btn btn-primary float-right m-r-10 m-b-10" variant="primary" onClick={this.handleYes}>
                                            Yes
                                         </Button>
                                        <Button variant="dark" onClick={this.closeYesModal}>
                                            No
                                        </Button>

                                    </Modal.Footer>
                                </Modal>

                            </Row>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}